// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_nb-0";